import researchVec from "../res/vectors/research-b.png";
import scienceVec from "../res/vectors/science-b.png";
import techVec from "../res/vectors/tech-b.png";

const Feature = ({ icon, title, description }) => (
  <div className="flex items-center gap-4">
    <div className="flex-shrink-0 bg-sky-200/50 p-3 rounded-full">
      <img className="h-8 w-8" src={icon} alt={`${title} icon`} />
    </div>
    <div>
      <h3 className="font-semibold text-sky-900">{title}</h3>
      <p className="text-sm text-slate-500">{description}</p>
    </div>
  </div>
);

function About() {
  return (
    <section id="about" className="bg-sky-50/75 py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center lg:text-left lg:max-w-2xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-sky-900 tracking-tight">
            About The Journal
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Promoting and advancing scientific knowledge and technological
            innovations across a wide range of disciplines.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-start">
          {/* Left Column: Icons/Features */}
          <div className="lg:col-span-1 flex flex-col gap-8">
            <Feature
              icon={researchVec}
              title="Peer-Reviewed"
              description="All published articles undergo a rigorous peer-review process."
            />
            <Feature
              icon={scienceVec}
              title="Open Access"
              description="Freely available to readers worldwide to facilitate knowledge sharing."
            />
            <Feature
              icon={techVec}
              title="Semi-Annual"
              description="Providing a timely platform for researchers to share their latest findings."
            />
          </div>

          {/* Right Column: Main Text */}
          <div className="lg:col-span-2 text-slate-700 space-y-4 text-base leading-relaxed">
            <p>
              The Asian Journal of Research in Science and Technology (AJORIST)
              is a prestigious online research journal dedicated to promoting
              and advancing scientific knowledge and technological innovations
              across a wide range of disciplines. With a focus on the Asian
              region and its contributions to the global scientific community,
              AJORIST provides a platform for researchers, scientists,
              academicians, and professionals to publish their original research
              papers.
            </p>
            <p>
              <strong className="font-semibold text-sky-900">
                Asian Journal of Research in Science and Technology (AJORIST)
                publishes semi-annually.
              </strong>{" "}
              By publishing twice a year, AJORIST provides a timely platform for
              researchers to share their latest findings, engage in scientific
              discussions, and contribute to the advancement of knowledge.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
